export default {
    users: {
        profile: {
            update_profile: 'Обновление прошло успешно!',
            update_password: 'Пароль обновлен!',
        }
    }
}
